import RequestService from '../requestService';
import { client } from '../../client';
import { Journalkategori, JournalkategoriLight, SakstypeUniqueLight } from '../../../models';

export default class journalkategoriDbViewService extends RequestService<Journalkategori, 'journalkategori'> {
    OpprettDatabaseViewForJournalkategori =
        async (journalkategori: number) =>
            client.post<number>(`${this.serviceName}/opprett_databaseView_for_journalkategori`, journalkategori);

    //   HentAlleJournalkategorierLight = 
    //   async (journalkategori: string) => 
    //         client.get<Journalkategori>(`${this.serviceName}/HentJournalkategorier`, journalkategori);
    HentAlleJournalkategorierLight =
        async () =>
            client.get<JournalkategoriLight[]>
                (`${this.serviceName}/hentJournalkategoriLightListe`) as unknown as JournalkategoriLight[];
}
